module.exports = __webpack_public_path__ + "static/media/Mamanero_Logo.a4d8b360.svg";